import dates from "i18n/translations/en/dates.json"

export const getDayMonthYearFromDate = (date: Date) => {
  const day = date.getDate();
  const month = date.getMonth();
  const year = date.getFullYear();

  return { day, month, year };
};

export const parseDateAndTime = (date: string) => {
  const dateTime = new Date(date);
  const formattedDateTime = dateTime.toLocaleString("pt-BR", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });

  return formattedDateTime;
};

export const saveDateOnUrlParams = (date: Date) => {
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  const urlParams = new URLSearchParams(window.location.search);
  urlParams.set("month", month.toString());
  urlParams.set("year", year.toString());

  window.history.replaceState(
    {},
    "",
    `${window.location.pathname}?${urlParams}`
  );
};

export const tryRetrieveDateFromUrlParams = () => {
  const params = new URLSearchParams(window.location.search);
    const month = params.get("month");
    const year = params.get("year");

    if (month && year) {
      return new Date(parseInt(year), parseInt(month) - 1);
    }

    const date = new Date();
    saveDateOnUrlParams(date);
    return date;
}

export const getMonthNames = (): string[] => {
  return Object.keys(dates.months);
}
